import {Component, OnInit, Inject, ViewEncapsulation, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents} from '@irb-common/events';
import { ImportSecurityModelsResultGridLayoutService } from '@irb/irb-models/import-security-model-result-dialog/import-security-model-result.grid-layout.service';
import {ModelsService, IModelImportSave} from '@irb/irb-models//models-new/models.service';
import {IAlertDialogData} from "@irb/app.model";

@Component({ standalone: false,
  selector: 'irb-import-security-model-result-dialog',
  templateUrl: './import-security-model-result-dialog.component.html',
  styleUrls: ['./import-security-model-result-dialog.component.scss', '../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportSecurityModelsResultDialogComponent implements OnInit, OnDestroy {
  grid: any;
  gridOptions: any;
  progressTimer: any = null;
  updateStatusCount = 0;
  isUiTest = false;
  frameworkComponents: any;

  constructor(
      public dialogRef: MatDialogRef<ImportSecurityModelsResultDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public as: AppService,
      private gls: ImportSecurityModelsResultGridLayoutService,
      public modelsService: ModelsService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    const r = {} as IModelImportSave;
    r.modelsToAdd = this.data.modelsToAdd;

    if (this.data.securitiesToAdd && this.data.securitiesToAdd.length > 0) {

      r.securitiesToAdd = this.data.securitiesToAdd;
    }

    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.modelsService.updateImportSecurityModels(r).subscribe((data: any) => {
      this.progressTimer && clearTimeout(this.progressTimer);
      this.actionStatusCheckIntervalStart(data.responseUtilityMap.statusId);
      this.close();

    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.close();
    });
  }

  updateProgressBarStatus(response: any) {
    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
    if (this.isUiTest)
      timeout = 0;
    this.updateStatusCount++;
    this.progressTimer = setTimeout(() => {
      this.actionStatusCheckIntervalStart(response.statusId);
    }, timeout);
  }

  actionStatusCheckIntervalStart(statusId: any) {
    this.modelsService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const response = statusResponse.responseData;
        const reqStatus = response.reqStatus.trim().toUpperCase();
        if (reqStatus === 'FAILED') {
          if (response.failMsg && response.failMsg.toUpperCase() === 'STALEDATAEXCEPTION')
            this.showStaleDataDialog();
          else
            this.actionStatusCheckFailed();

          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          this.updateProgressBarStatus(response);
        }
        if (reqStatus === 'COMPLETED') {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.progressTimer && clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'success',
            summary: 'Import Security Models',
            detail: response.successRecCount + " Security model(s) were sucessfully imported."
          });
          this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
        }
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        this.progressTimer && clearTimeout(this.progressTimer);
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.progressTimer && clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    } as IAlertDialogData);
  }

  showStaleDataDialog() {
    this.close();
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dTitle: 'Refresh Required',
      dProceedBtnLabel: 'Refresh',
      msg: "You are attempting to import models which were modified by another user. Please refresh page to see latest changes.",
      onProceed: () => {
        this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      }
    });
  }

  ngOnDestroy() {
    this.progressTimer && clearTimeout(this.progressTimer);
  }
}
